import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Signingreasons } from 'src/app/models/signingreasons';

@Component({
  selector: 'app-reasonlistitem',
  templateUrl: './reason-list-item.component.html'
})
export class ReasonListItemComponent implements OnInit {
  @Input('reason') reason!: Signingreasons;
  @Output('RemoveReason') RemoveReason: EventEmitter<number> = new EventEmitter<number>();
  currentUrl: any[] = [];

  constructor() {
    // Must not be empty. It's approved by a comment.
  }

  ngOnInit(): void {
    // Must not be empty. It's approved by a comment.
  }

  removeReason(reasonId: number) {
    this.RemoveReason.emit(reasonId);
  }


}
